const SOCIAL_INSTAGRAM_AWARENESS_MULTIPLIER = {
    views: 0.05,
    reach: 0.003,
  };

  const SOCIAL_INSTAGRAM_STORY_AWARENESS_MULTIPLIER = {
    impressions: 0.05,
    estimatedImpressions: 0.05,
  };

  const SOCIAL_TIKTOK_AWARENESS_MULTIPLIER = {
    views: 0.03,
  };

  const SOCIAL_YOUTUBE_AWARENESS_MULTIPLIER = {
    views: 0.15,
  };

  const SOCIAL_YOUTUBE_SHORT_AWARENESS_MULTIPLIER = {
    views: 0.03,
  };

  const SOCIAL_PINTEREST_AWARENESS_MULTIPLIER = {
    impressions: 0.007,
  };

  const SOCIAL_FACEBOOK_AWARENESS_MULTIPLIER = {
    reach: 0.007,
  };

  const SOCIAL_TWITTER_AWARENESS_MULTIPLIER = {
    reach: 0.007,
  };

  export const POST_TYPE_AWARENESS_MULTIPLIER_MAP: Record<string, Record<string, number>> = {
    instagram_post: SOCIAL_INSTAGRAM_AWARENESS_MULTIPLIER,
    instagram_reel: SOCIAL_INSTAGRAM_AWARENESS_MULTIPLIER,
    instagram_story: SOCIAL_INSTAGRAM_STORY_AWARENESS_MULTIPLIER,
    instagram_video: SOCIAL_INSTAGRAM_AWARENESS_MULTIPLIER,
    tiktok_video: SOCIAL_TIKTOK_AWARENESS_MULTIPLIER,
    youtube_video: SOCIAL_YOUTUBE_AWARENESS_MULTIPLIER,
    youtube_short: SOCIAL_YOUTUBE_SHORT_AWARENESS_MULTIPLIER,
    pinterest: SOCIAL_PINTEREST_AWARENESS_MULTIPLIER,
    facebook: SOCIAL_FACEBOOK_AWARENESS_MULTIPLIER,
    twitter: SOCIAL_TWITTER_AWARENESS_MULTIPLIER,
  };
